<template>
  <div class="result" v-if="show">
    <van-popup
      v-model="show"
      :overlay="overlay"
      overlay-class="my-popup"
      @click="bindClose"
      :lock-scroll="false"
    >
      <div
        class="r-content animate__animated animate__bounceIn"
        @click.stop
        :style="animateStyle"
      >
        <div class="swiper-container">
          <div
            class="operate-btn"
            :class="[overlay ? '' : 'operate-btn-opacity']"
            v-show="data.length > 1"
          >
            <div
              class="operate-item operate-before"
              :class="[showBefore ? '' : 'gray']"
              @click="bindClickBefore"
              ><span class="iconfont icon-fanhui"></span
            ></div>
            <div
              class="operate-item operate-after"
              :class="[showAfter ? '' : 'gray']"
              @click="bindClickAfter"
            >
              <span class="iconfont icon-fanhui"></span>
            </div>
          </div>
          <div class="card-swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in data"
                :key="index"
              >
                <div class="card-content" :ref="'cardResult' + index">
                  <img class="card-image" :src="item.icon" alt="" />
                  <!-- <div class="card-fixed">
                                        <img class="qrcode"
                                            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eeef1fe915c5b2f7d01914ef1ccb1cdb.png"
                                            alt="">
                                        <div class="card-text">扫码抽签</div>
                                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-content">
          <div class="btn-list" :class="[overlay ? '' : 'btn-opacity']">
            <div
              class="btn-item btn-left"
              @click="bindShare"
              v-buried
              v-clickBuried
              data-click-buried="CLICK_CQHD_QJQ"
              data-buried="BG_CQHD_QJQ"
              >去解签</div
            >
          </div>
          <div class="close iconfont icon-cha" @click="bindClose"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Swiper from 'swiper/swiper-bundle.min.js'
import html2canvas from 'html2canvas'
import 'swiper/swiper-bundle.min.css'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    isResultType: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.init()
      } else {
        this.destroySwiper()
      }
    }
  },
  computed: {
    showBefore() {
      return this.active > 0
    },
    showAfter() {
      return this.active < this.data.length - 1
    }
  },
  data() {
    return {
      swiper: null,
      show: false,
      overlay: true,
      animateStyle: {},
      active: 0
    }
  },
  created() {},
  mounted() {},
  methods: {
    bindSave() {
      this.$toast.loading()
      let el = this.$refs['cardResult' + this.active]
      el = Array.isArray(el) ? el[0] : el
      html2canvas(el, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$betterwe.onAppSaveImage({
            data: canvas.toDataURL(),
            type: 'base64'
          })
        })
        .catch((err) => {
          console.log(err)
          this.$toast('生成失败')
        })
        .finally(() => {
          this.$toast.clear()
        })
    },
    bindShare() {
      this.$emit('share', this.data[this.active])
    },
    bindClickBefore() {
      this.swiper.slidePrev()
    },
    bindClickAfter() {
      this.swiper.slideNext()
    },
    init() {
      this.overlay = true
      this.show = true
      this.animateStyle = {}
      this.active = 0
      this.$nextTick(() => {
        this.initSwiper()
      })
      /* 禁止在执行打开动画时关闭 */
      this.disabledClick = true
      setTimeout(() => {
        this.disabledClick = false
      }, 600)
    },
    destroySwiper() {
      this.swiper?.destroy(false)
    },
    initSwiper() {
      let self = this
      this.swiper = new Swiper('.card-swiper', {
        slidesPerView: 'auto', //每页显示数量，auto为自动填充，3为每页显示3块
        centeredSlides: true, //轮播图自动居中
        spaceBetween: '0%', //轮播图左右之间的间距，配合css样式中的width实现效果
        initialSlide: 0, //轮播图初始下标位置
        //方法事件
        on: {
          //回调函数，swiper从当前slide开始过渡到另一个slide时执行
          slideChange: function () {
            self.active = this.activeIndex
          }
        }
      })
    },
    bindClose() {
      if (this.disabledClick) {
        return
      }
      this.overlay = false
      //15.2%"
      this.setCardPosition(this.index)
      setTimeout(() => {
        this.show = false
        this.$emit('input', false)
        if (this.isResultType) {
          this.$emit('change', this.index)
        }
      }, 500)
    },
    setCardPosition(index) {
      let el = document.getElementById('card-item-' + index)
      let scrollTop = window.document.documentElement.scrollTop || 0
      let left = el.offsetLeft + el.clientWidth / 2
      let top = el.offsetTop + el.clientHeight / 2 - scrollTop
      this.animateStyle = {
        left: left + 'px',
        top: top + 'px',
        animation: 'myScale 0.5s ease',
        transform: 'translate(-50%, -50%) scale(0.1)'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  ::v-deep .van-popup {
    background-color: transparent;
    width: 100%;
    height: 100%;
  }

  .r-content {
    width: 100vw;
    position: absolute;
    transition: all 0.5s ease;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: cardScale 0.3s ease;

    .swiper-container {
      position: relative;

      .operate-btn {
        opacity: 1;
        transition: opacity 0.5s ease;

        .operate-item {
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #fff;
          border-radius: 50%;
          z-index: 999;
          position: absolute;
          top: 50%;
          transform: translate(0%, -50%);
        }

        .gray {
          border: 1px solid rgb(124, 121, 121);
          color: rgb(124, 121, 121);
        }

        .operate-before {
          left: 36px;
        }

        .operate-after {
          right: 36px;

          .iconfont {
            transform: rotate(180deg);
          }
        }
      }

      .operate-btn-opacity {
        opacity: 0;
      }
    }

    .card-swiper {
      width: 100%;
      overflow: hidden;
    }

    .card-content {
      margin: 0 auto;
      width: 241px;
      height: 530px;
      margin-bottom: 10px;
      position: relative;

      .card-image {
        width: 100%;
        height: 100%;
      }

      .card-fixed {
        text-align: center;
        position: absolute;
        right: 35px;
        bottom: 40px;

        .qrcode {
          width: 35px;
          height: 35px;
        }

        .card-text {
          white-space: nowrap;
          position: absolute;
          left: 50%;
          bottom: -13px;
          font-size: 12px;
          color: #818181;
          transform: translate(-50%, 0%) scale(0.65);
        }
      }
    }
    .btn-content {
      position: relative;
      width: 235px;
      margin: 0 auto;
    }

    .close {
      width: 26px;
      height: 26px;
      border: 1px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 50%;
      position: absolute;
      top: 54px;
      left: 50%;
      transform: translate(-50%, 0%);
    }

    .btn-list {
      opacity: 1;
      transition: opacity 0.5s ease;
      display: flex;
      padding: 0px 12px;
      align-items: center;
      justify-content: center;

      .btn-item {
        width: 102px;
        height: 34px;
        font-size: 12px;
        text-align: center;
        font-family: MiSans-Demibold, MiSans;
        font-weight: 600;
        color: #605989;
        line-height: 34px;
        border-radius: 17px;
        border: 1px solid;
      }

      .btn-right {
        border: 1px solid #fff;
        color: #fff;
      }

      .btn-left {
        background: linear-gradient(180deg, #fffff4 0%, #e7c1ff 100%);
        box-shadow: inset 0px 1px 3px 3px rgba(255, 255, 255, 0.5);
      }
    }

    .btn-opacity {
      opacity: 0;
    }
  }

  .swiper-wrapper {
    align-items: flex-end;
  }

  /* 每个轮播图占比大小，100%则整个屏幕铺满 */
  .swiper-slide {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

@keyframes myScale {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }

  100% {
    transform: translate(-50%, -50%) scale(0.1);
  }
}

@keyframes cardScale {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }

  44% {
    transform: translate(-50%, -50%) scale(1.1);
  }

  66% {
    transform: translate(-50%, -50%) scale(1);
  }

  88% {
    transform: translate(-50%, -50%) scale(0.9);
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
</style>
